import { reactive } from "vue";
export const quickDirectoryStore = reactive({
    data: {},
    setData(directory) {
        directory.forEach(value => {
            this.data[value.pageTag] = [];

            const nodes = this.getFirstNodes(value);
            const arr = this.parseArray(Object.values(nodes));
            this.data[value.pageTag] = arr;
            console.log("result = ", arr);
        });


        console.log("data::", this.data);
    },
    getFirstNodes(pageTag) {
        const result = {}
        pageTag.child.forEach(item => {
            result[item.pageIndex] = [];
            this.getPages(item, result[item.pageIndex]);
        });

        return result;
    },
    getPages(parent, arr) {
        if(parent.child.length > 0) {
            parent.child.forEach(item => {
                this.getPages(item, arr);
            })
        }else {
            arr.push(parent.pageIndex);
        }
    },
    /**
     * 
     * @param {Object} nodes 
     */
    parseArray(nodes) {
        const groups = {}
        nodes.forEach(item => {
            item.forEach(child => {
                groups[child] = item.slice();
            })
        });

        return groups;
    }
})